import styled from 'styled-components';

const HomepageTitle = styled.h1`
  text-align: center;
  margin: 1rem 0;
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { HomepageTitle, HeaderContainer };
